export default "__VITE_ASSET__DAXwZHu3__"